import { MigrationData } from './MigrationData';
import { Component, OnInit } from '@angular/core';
import { CountryList } from './GroupedCountryList';
import { DataService } from './data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [
    './app.component.scss',
  ]
})
export class AppComponent implements OnInit {

    migrationData: MigrationData;

    countries: CountryList;

  constructor(private dataService: DataService) { }

  private getData() {
    this.dataService.getMigrationData().subscribe(res => this.migrationData = res);
  }

  private getCountries() {
    this.dataService.getCountries().subscribe(res => this.countries = res);
  }

  ngOnInit(){
    this.getData();
    this.getCountries();
  }
}



// WEBPACK FOOTER //
// D:/Workspace/hyblab-migration/src/app/app.component.ts